import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"icon-back\">\n\t<g id=\"icon-back_标准网格\"></g>\n\t<g id=\"icon-back_图层_2\">\n\t\t<path d=\"M423.1,356.4V178.7L112,489.7l311.1,311.2V618.6c222.2,0,377.8,71.1,488.9,226.7C867.6,623.1,734.3,400.9,423.1,356.4\" />\n\t</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol